import { atom } from 'recoil'

const SubjectAtom = atom({
  key: 'SubjectAtom',
  default: 0
})

export default SubjectAtom
